"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface OtherReceivablesTailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  { 
    id: "othrec-1", 
    question: "Are there any material allowances for doubtful debts in other receivables?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "othrec-2", 
    question: "Are there accounting estimates apart from allowances for doubtful debts in other receivables?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "othrec-3", 
    question: "Is there any material classification between current and non-current portion of other receivables?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "othrec-4", 
    question: "Does the entity have material outstanding advances to suppliers during the period?", 
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "othrec-4-follow",
      question: "Are we planning on sending confirmations for testing the balance?",
      type: "radio",
      options: ["Yes", "No"],
    },
  },
  { 
    id: "othrec-5", 
    question: "Does the entity have material outstanding capital advances during the period?", 
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "othrec-5-follow",
      question: "Are we planning on sending confirmations for testing the balance?",
      type: "radio",
      options: ["Yes", "No"],
    },
  },
];

export default function OtherReceivablesTailoringQuestions({ onBack }: OtherReceivablesTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Other Receivables"
      title="Other Receivables - Tailoring Questions"
      description="Customize the audit program for Other Receivables"
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}
